<template functional>
    <div>
        {{ $t('Unsupported response type: {type}', {type: props.item.response_type}) }}
    </div>
</template>

<script>

    export default {
        props: {
            item: {
                type: Object,
                required: true,
            },
            resource: {
                type: Object,
                default: null,
            },
        },
    };
</script>
